<template>
  <div class="w100">
    <div class="w100 pt20 pb20 pl20 pr20 bg-w" v-loading="loading01">
      <p class="w100 bold mb20 font-18 tx-c">今日大厅访问</p>
      <!-- <div class="tx-c">
        <span class="po-r in-block font-18 blue title">今日大厅访问</span>
      </div> -->
      <el-row class="mt20 count" v-if="data1.length > 0">
        <el-col class="tx-c up down" :span="8" v-for="(item, index) in data1" :key="index" :style="{ 'background-image': item.level == 'up' ? `url(${baseUrl}/images/icon-up.png)` : item.level == 'down' ? `url(./images/icon-down.png)` : '' }">
          <p class="grey mb10 font-14">{{ item.label }}</p>
          <p class="font-36">{{ item.value }}</p>
        </el-col>
      </el-row>
      <p class="w100 pt20 pb20 tx-c grey" v-else>暂无数据</p>
    </div>

    <div class="w100 mt20 pt20 pb20 pl20 pr20 bg-w">
      <p class="w100 bold mb20 font-18 tx-c">大厅访问趋势</p>
      <!-- <div class="tx-c">
        <span class="po-r in-block font-18 blue title">大厅访问趋势</span>
      </div> -->

      <div class="w100 mt20 flex-box al-c">
        <DateComp class="mr10" ref="date" :loading="loading02" @change="getValue" />
        <el-button type="primary" size="mini" @click="getValue">查询</el-button>
      </div>

      <div class="w100 mt20" v-loading="loading02">
        <ve-line :extend="option"></ve-line>
      </div>
    </div>
  </div>
</template>

<script>
import DateComp from "@/components/ServeCount/DateComp";

export default {
  name: "ByHallHead",
  components: {
    DateComp
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      loading01: false,
      data1: [],

      loading02: false,
      option: {
        color: ["#41b854", "#44b9fe", "#d9d93c"],
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: []
        },
        grid: {
          show: true,
          left: "3%",
          right: "4%",
          bottom: "5%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          name: "时间",
          type: "category",
          boundaryGap: false,
          data: []
        },
        yAxis: {
          name: "值",
          type: "value"
        },
        series: []
      }
    };
  },
  created() {},
  computed: {},
  mounted() {
    this.fetchToday();
    this.fetchAllData();
  },
  methods: {
    fetchToday() {
      this.loading01 = true;
      this.$http
        .post("viewStatistics/countVisit", {})
        .then(({ data }) => {
          // console.log(data);
          if (data.RetCode && data.RetStatus == 0) {
            this.data1 = data.RetData;
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
          this.loading01 = false;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "操作失败，请检查网络",
            type: "error",
            offset: 60
          });
          this.loading01 = false;
        });
    },
    getValue(value) {
      this.fetchAllData();
    },
    fetchAllData() {
      let obj = {};
      const date = this.$refs.date.getValue();
      obj.startTime = date[0] + " 00:00:00";
      obj.endTime = date[1] + " 23:59:59";
      console.log(obj);

      this.loading02 = true;
      this.$http
        .post("viewStatistics/getchartData", this.$qs.stringify(obj))
        .then(({ data }) => {
          // console.log(data);
          if (data.RetCode) {
            // this.data1 = data.RetData;
            this.option.legend.data = data.RetData.yData.map(val => val.name);
            this.option.xAxis.data = data.RetData.xData;
            this.option.series = data.RetData.yData;
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
          this.loading02 = false;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "操作失败，请检查网络",
            type: "error",
            offset: 60
          });
          this.loading02 = false;
        });
    }
  }
};
</script>

<style scoped>
.title::before,
.title::after {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  margin-top: -1px;
  width: 100px;
  height: 1px;
  background: #475eb7;
}

.title::before {
  right: 130%;
}

.title::after {
  left: 130%;
}

.count .up,
.count .down {
  background: no-repeat 80% center;
  background-size: auto 60px;
}
</style>
